export enum ServiceType {
  OIL_CHANGE = 'oilChange',
  FILTER_CHANGE = 'filterChange',
  TIRE_CHANGE = 'tireChange',
  REPAIR = 'repair',
}
